import { Option } from 'types/types';

declare global {
  interface Array<T> {
    labelByValue(this: Option[], value: string | undefined): string | undefined;
    optionByValue(this: Option[], value: string | undefined): Option | undefined;
  }
}

Array.prototype.labelByValue = function (value: string | undefined): string | undefined {
  return this.find((x: Option) => x.value === value)?.label;
};

Array.prototype.optionByValue = function (value: string | undefined): Option | undefined {
  return this.find((x: Option) => x.value === value);
};

export {};
